import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import Modal from 'react-modal';

import './optimisation-dashboard.scss';
import { DashboardHeader } from '../../atoms';
import {  DashContainer, DashContentFooter,OptimisationContainer } from '../../molecules';
import { DashboardContext, UserContext } from '../../../context';

function OptimisationDashboard() {
  Modal.setAppElement('#root');

  const [dashData, setDashData] = useState({});

  useEffect(() => {
    document.body.style.backgroundColor = '#ffffff';
  });


  return (
    <DashboardContext.Provider value={{ dashData, setDashData }}>
      <div className='row no-gutters'>
        <div className='no-gutters dash-left-wrapper'>
          <DashboardHeader />
          <OptimisationContainer />
          <DashContentFooter className='footer-margin' />
        </div>

      </div>

    </DashboardContext.Provider>
  );
}

export default OptimisationDashboard;
